<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <v-card v-else>
          <card-header :title="title"></card-header>

          <v-form ref="form" v-model="valid">
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field v-model="password" :label="field.label" type="password"
                    :rules="[rules.min, rules.required]" dense></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>

          <v-card-actions class="mt-3">
            <v-spacer></v-spacer>
            <custom-button @click="handleSubmit" :label="formButton.name" :disabled="!valid" color="primary" size="lg"
              gradient rounded></custom-button>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardHeader from '@/components/cards/CardHeader.vue';
import { passwordInfo } from '@/views/ProfileView/fields';

import { authApi } from "@/api/api";

import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

export default {
  components: {
    CardHeader,
    CustomButton,
    LoadingSpinner,
  },
  data() {
    return {
      title: "비밀번호 수정",
      formButton: {
        name: "저장",
      },
      field: passwordInfo,
      isLoading: false,
      password: '',
      rules: {
        required: v => !!v || "값을 입력하세요.",
        min: v => v.length >= 8 || "8자 이상의 값을 입력하세요.",
      },
      valid: false,
    }
  },
  methods: {
    async handleSubmit() {
      await this.updatePassword();
    },
    async updatePassword() {
      const body = {
        password: this.password,
      }

      try {
        this.isLoading = true;
        const response = await authApi.changePassword(body);

        if (response && response.status === 200) {
          this.notifyVue('top', 'center', '비밀번호를 변경하였습니다.', 'info');
        }
      } catch (error) {
        if (error.response.status === 400 && error.response.data.code === "sns_registered") {
          const message = error.response.data.message;
          this.notifyVue('top', 'center', `${message}로 가입한 계정입니다. 비밀번호 변경이 불가합니다.`);
        } else {
          this.notifyVue('top', 'center', this.$t('alert.failed_request'));
        }
      } finally {
        this.isLoading = false;
      }
    },
    notifyVue(verticalAlign, horizontalAlign, alertMessage, alert_type) {
      this.$notify({
        timeout: 8000,
        message: alertMessage,
        icon: "priority_high",
        type: alert_type ? alert_type : "danger",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
      });
    },
  },
};
</script>
<style lang="scss">
.text-right {
  display: flex;
}

.simple-card-title {
  color: #565656;
  font-weight: 500;
  font-size: medium;
}

.simple-card-sub-title {
  color: gray;
  font-size: small;
}
</style>
